import React, { useEffect, useState } from "react";
import { History } from "lucide-react";
import { Tile, Badge } from "../Primitives";
import { relTime } from "./shared";
import { listKeyAudit } from "../../lib/integrationsApi";

const ACTION_STATUS = { created: "success", updated: "info", cleared: "warning", deleted: "critical", tested: "neutral", activated: "info" };

export default function KeyAuditLog({ actor, refreshKey }) {
  const [events, setEvents] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    listKeyAudit(actor).then(r => { setEvents(r.events); setErr(null); }).catch(e => setErr(e.message));
  }, [actor, refreshKey]);

  return (
    <Tile testid="key-audit-log" dense
          title={<span className="text-[11px] font-semibold tracking-widest uppercase text-muted inline-flex items-center gap-2"><History size={12} className="text-primary" /> Change history</span>}
          action={events && <span className="text-[10px] text-subtle font-mono-tabular">{events.length} events · values never logged</span>}>
      {err && <div className="p-4 text-[11px] text-critical">{err}</div>}
      {events && events.length === 0 && (
        <div data-testid="key-audit-empty" className="p-6 text-center text-[12px] text-muted">No changes yet. Every add, update, test, clear and provider switch is recorded here.</div>
      )}
      {events && events.length > 0 && (
        <div className="overflow-x-auto">
          <table className="w-full text-[11.5px]">
            <thead>
              <tr className="text-[10px] uppercase tracking-widest text-subtle border-b border-border">
                <th className="text-left font-semibold px-4 py-2">When</th>
                <th className="text-left font-semibold px-4 py-2">Service</th>
                <th className="text-left font-semibold px-4 py-2">Action</th>
                <th className="text-left font-semibold px-4 py-2">By</th>
                <th className="text-left font-semibold px-4 py-2">Detail</th>
              </tr>
            </thead>
            <tbody>
              {events.map(e => (
                <tr key={e.id} data-testid={`key-audit-row-${e.id}`} className="border-b border-border/60 hover:bg-surface-2/50">
                  <td className="px-4 py-2 font-mono-tabular text-muted whitespace-nowrap" title={e.ts}>{relTime(e.ts)}</td>
                  <td className="px-4 py-2 whitespace-nowrap">{e.label}</td>
                  <td className="px-4 py-2"><Badge status={ACTION_STATUS[e.action] || "neutral"}>{e.action}</Badge></td>
                  <td className="px-4 py-2 font-mono-tabular whitespace-nowrap">{e.actor}</td>
                  <td className="px-4 py-2 text-muted min-w-[220px]">{e.fields?.length ? `fields: ${e.fields.join(", ")}` : ""}{e.detail}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Tile>
  );
}
